import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDMYtGAzaMkVcQH43dE3nOGm-z8OnCVCzw",
    authDomain: "babylon-app-52837.firebaseapp.com",
    projectId: "babylon-app-52837",
    storageBucket: "babylon-app-52837.firebasestorage.app",
    messagingSenderId: "712561406143",
    appId: "1:712561406143:web:2a035cbba2a637bec1160a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);